import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const root = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};
`

// Stack the title above the bulleted list. AlertPanel lays its children out in
// a horizontal flex row, so the title text and the <ul> must share one column
// wrapper — otherwise they render side by side and the bullets misalign against
// the title baseline.
export const warnings = css`
  display: flex;
  flex-direction: column;
`

export const warningsList = css`
  margin: ${spacing(1)} 0 0;
  padding-left: ${spacing(4)};
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
`
